import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  InputAdornment,
  IconButton,
  MenuItem
} from '@mui/material'
import {
  Visibility,
  VisibilityOff,
  Restaurant,
  PersonAdd
} from '@mui/icons-material'
import { useAuth } from '../contexts/AuthContext'

const Register = () => {
  const navigate = useNavigate()
  const { register: registerUser } = useAuth()
  const { register, handleSubmit, formState: { errors } } = useForm()
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmit = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)

    try {
      const result = await registerUser({
        nome: data.nome,
        cpf: data.cpf,
        password: data.password,
        tipo: data.tipo
      })

      if (result.success) {
        setSuccess('Cadastro realizado com sucesso! Redirecionando...')
        setTimeout(() => {
          navigate('/login')
        }, 2000)
      } else {
        setError(result.message)
      }
    } catch (err) {
      setError('Erro ao cadastrar. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Restaurant sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Cadastro
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Crie sua conta no sistema
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <TextField
            fullWidth
            label="Nome Completo"
            margin="normal"
            {...register('nome', {
              required: 'Nome é obrigatório',
              minLength: {
                value: 3,
                message: 'Nome deve ter no mínimo 3 caracteres'
              }
            })}
            error={!!errors.nome}
            helperText={errors.nome?.message}
          />

          <TextField
            fullWidth
            label="CPF"
            margin="normal"
            {...register('cpf', {
              required: 'CPF é obrigatório',
              pattern: {
                value: /^\d{11}$/,
                message: 'CPF deve conter 11 dígitos'
              }
            })}
            error={!!errors.cpf}
            helperText={errors.cpf?.message}
            placeholder="00000000000"
          />

          <TextField
            fullWidth
            select
            label="Tipo de Usuário"
            margin="normal"
            defaultValue="produtor"
            {...register('tipo', { required: 'Tipo é obrigatório' })}
            error={!!errors.tipo}
            helperText={errors.tipo?.message}
          >
            <MenuItem value="produtor">Produtor Rural</MenuItem>
            <MenuItem value="agroeconomia">Agroeconomia</MenuItem>
            <MenuItem value="educacao">Educação</MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Senha"
            type={showPassword ? 'text' : 'password'}
            margin="normal"
            {...register('password', {
              required: 'Senha é obrigatória',
              minLength: {
                value: 6,
                message: 'Senha deve ter no mínimo 6 caracteres'
              }
            })}
            error={!!errors.password}
            helperText={errors.password?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 3, mb: 2 }}
            startIcon={<PersonAdd />}
            disabled={loading}
          >
            {loading ? 'Cadastrando...' : 'Cadastrar'}
          </Button>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Link
              to="/login"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Typography variant="body2" color="primary">
                Já tem conta? Faça login
              </Typography>
            </Link>
          </Box>
        </form>
      </Paper>
    </Container>
  )
}

export default Register

